module.exports = __webpack_public_path__ + "static/media/page-404.af98508d.jpg";